import { useMemo } from 'react'

import { createDedupedMessageApi } from '../utils/messageDedup'

type MessageMethodName = 'error' | 'success' | 'warning' | 'info'
type MessageApiLike = Partial<Record<MessageMethodName, unknown>>

export const useDedupedMessage = <T extends MessageApiLike>(messageApi: T): T =>
    useMemo(() => createDedupedMessageApi(messageApi), [messageApi])
